import { NGXLogger as LoggerService, NgxLoggerLevel } from 'ngx-logger';

/**
 * Sends ONE warn to `/uilogging` although dev/prod only forward ERROR and above (`ngxServerLoggerLevel: 5`):
 * `serverLogLevel` is lowered to WARN for this single call and restored afterwards. ngx-logger decides
 * synchronously inside `_log` whether the server path runs, so the switch is safe. Use sparingly and
 * once per session per marker - every report becomes an Error Reporting event on the server side
 * (the `/uilogging` handler knows no levels, `levelName: WARN` only sits in the body).
 * Used by AppCheckTelemetryService (`AppCheck: token error`) and ConnectionStalledReporter (`ConnectionStalled:`).
 */
export function warnToServer(logger: LoggerService, message: string, ...additional: unknown[]): void {
    const previousLevel = logger.getConfigSnapshot().serverLogLevel;
    const lowerLevel = previousLevel === undefined || previousLevel > NgxLoggerLevel.WARN;
    if (lowerLevel) logger.partialUpdateConfig({ serverLogLevel: NgxLoggerLevel.WARN });
    try {
        logger.warn(message, ...additional);
    } finally {
        if (lowerLevel) logger.partialUpdateConfig({ serverLogLevel: previousLevel });
    }
}
